import React, { Component } from 'react';
import './App.css';
//import logo from './logo.svg';
//import eeiLogo from './logo-eei-large.jpg'
import logo from './logo-strata.png'
//import AppRouter from './AppRouter';

import { Fabric } from 'office-ui-fabric-react/lib/Fabric';

import { initializeIcons } from '@uifabric/icons';

import Login from './login/containers/Login'
import Assessments from './assessments/containers/Assessments'
import Admin from './admin/containers/Admin'

/*
import OfficeTest from './test/components/Test0'

import Test1 from './test/containers/Test1'
import Test2 from './test/containers/Test1'
*/

import Report from './assessments/containers/Report'



// Register icons and pull the fonts from the default SharePoint cdn:
initializeIcons();
// ...or, register icons and pull the fonts from your own cdn:
//initializeIcons('https://my.cdn.com/path/to/icons/');
//        <AppRouter />
//         <SomeComponent />
/*
*/
class App extends Component {
  render() {
    console.log('render')
    return (
      <Fabric>
        <header className="App-header">
        <div className="ms-Grid"><div className="ms-Grid-row">
        <div className="ms-Grid-col ms-lg2"><img src={logo} className="App-logo" alt="logo" /></div>
        <div className="ms-Grid-col ms-lgPush2 ms-lg2 ms-font-xl">Report</div>
        </div></div>
        </header>

        
        {/*<OfficeTest /><Test1 /><Test2 />*/}
        <Login />
        <Assessments />
        {/*<Report />*/}
        <Admin />
      </Fabric>
    );
  }
}

export default App;




// WEBPACK FOOTER //
// ./src/App.js